export default function cleanExistingSuffixes(catalogId: string): string {
  if (!catalogId) return catalogId

  if (typeof catalogId !== 'string') {
    return String(catalogId || '')
  }

  let result = catalogId.trim()
  // GO no es un sufijo de grupo especial - es parte del código de unidad Gola
  // Se maneja por separado con idCambioGolaBlanco
  const suffixes = new Set(['LA', 'RU', 'R2', 'LI', 'GO'])

  while (true) {
    const parts = result.split(' ')
    const last = parts[parts.length - 1]
    if (last && suffixes.has(last.toUpperCase())) {
      parts.pop()
      result = parts.join(' ').trimEnd()
      continue
    }
    break
  }

  return result
}
